var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.902 5.316L9.5 13.393 7.5 15l-2-1.607 1.598-8.077.402.542.402-.542zM15 3.19c-.285 2.342-3.861 2.12-3.861 2.12l1.64 2.17-2.635 1.06L9 4.906l1.74-1.716zm-10.74 0L6 4.906 4.856 8.54 2.22 7.48l1.641-2.17S.285 5.532 0 3.19h4.26zM9.372 0L10 1.11 7.5 4.179 5 1.111 5.627 0h3.746z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "static/svg/roles/support.svg";
export { SvgSupport as ReactComponent };